// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"10bty":[function(require,module,exports) {
require("37e082b46bb0aa0e").register(require("8df2cd897b26d95b").getBundleURL('3m6Pd'), JSON.parse("[\"3m6Pd\",\"iframe.c0a35ad3.js\",\"2IVb7\",\"Illustrations.ba1fef41.js\",\"1S9Xb\",\"Illustrations.9687f9a1.js\",\"faAEb\",\"Illustrations.9b588137.js\",\"6pVFi\",\"Illustrations.0ff885f4.css\",\"iMJmH\",\"Illustrations.e5d8064a.js\",\"2z1ui\",\"Illustrations.4ebe900e.js\",\"jLK1D\",\"Illustrations.624400be.js\",\"7IdUb\",\"Illustrations.7425119f.js\",\"1CBmB\",\"Illustrations.dd95a13c.css\",\"1KVrW\",\"Illustrations.17335321.js\",\"abwqH\",\"Illustrations.dc8eac67.js\",\"aE38n\",\"Illustrations.0b351af6.css\",\"kcbzr\",\"Illustrations.e66cc991.js\",\"6s2wE\",\"Illustrations.bbb6acdf.css\",\"cVTCK\",\"Intro.628dcc1d.js\",\"av2d4\",\"wallpaper_collaborative_S2_desktop.1ae295a9.webp\",\"lY76f\",\"Intro.cbabfba8.css\",\"27jgR\",\"Migrating.26157fe1.js\",\"edn3I\",\"Migrating.89a0dcec.css\",\"9kfi1\",\"Release Notes.ab7138f9.js\",\"4tmwb\",\"Release Notes.39e94151.css\",\"1XUR1\",\"Style Macro.230ec8d0.js\",\"9PocN\",\"Style Macro.68f4b5ac.css\",\"2KkmA\",\"Workflow Icons.fe138824.js\",\"k0yFy\",\"Workflow Icons.54c8e7bc.css\",\"dqtL6\",\"Accordion.stories.2efe6ab9.js\",\"cWUv6\",\"Accordion.stories.4b5476c2.css\",\"iEshU\",\"ActionButton.stories.8500751a.js\",\"037P9\",\"ActionButton.stories.161102f8.css\",\"jcgIU\",\"ActionMenu.stories.b09b3ba4.js\",\"aS05P\",\"ActionMenu.stories.d37ad1a6.css\",\"e3hOL\",\"AlertDialog.stories.9d7631be.js\",\"atafN\",\"AlertDialog.stories.558b6a20.css\",\"hU3Od\",\"Avatar.stories.568779ab.js\",\"d8rKi\",\"Avatar.stories.020a2bc5.css\",\"gwjKC\",\"AvatarGroup.stories.33729ace.js\",\"bOFAt\",\"AvatarGroup.stories.f941a3bf.css\",\"8y9xZ\",\"Badge.stories.631c5902.js\",\"dPehZ\",\"Badge.stories.7dccba53.css\",\"j0Ats\",\"Breadcrumbs.stories.b79a2fd9.js\",\"7zQ7W\",\"Breadcrumbs.stories.ecf4caba.css\",\"2jNf7\",\"Button.stories.0c0f4944.js\",\"5RsNc\",\"Button.stories.51830ff6.css\",\"eQ8bY\",\"ButtonGroup.stories.04a49f7e.js\",\"aAsBk\",\"ButtonGroup.stories.7c97a52c.css\",\"f4ayd\",\"Card.stories.b12d0974.js\",\"62XoY\",\"preview.fa2965aa.png\",\"7AU6B\",\"placeholder.f0db36ef.png\",\"bMIYu\",\"Card.stories.28f53d5a.css\",\"dPjT9\",\"CardView.stories.fa8b8a87.js\",\"5JJzb\",\"CardView.stories.9ba0883b.css\",\"fOdaS\",\"Checkbox.stories.80054dee.js\",\"2bolh\",\"Checkbox.stories.2c1ca09c.css\",\"ilGTn\",\"CheckboxGroup.stories.fa281d81.js\",\"2swXp\",\"CheckboxGroup.stories.b42fded6.css\",\"lncte\",\"ColorArea.stories.1d7e6c94.js\",\"fF9BN\",\"ColorArea.stories.40619976.css\",\"kLuH7\",\"ColorField.stories.ed7267b5.js\",\"6FPBo\",\"ColorField.stories.c013fb89.css\",\"jQR4s\",\"ColorSlider.stories.982cae62.js\",\"lopTr\",\"ColorSlider.stories.53aec799.css\",\"9VQBI\",\"ColorSwatch.stories.f62f404c.js\",\"a9AJF\",\"ColorSwatch.stories.a970768d.css\",\"3jLvg\",\"ColorSwatchPicker.stories.47cc562f.js\",\"jpqkd\",\"ColorSwatchPicker.stories.c6837141.css\",\"8SPgI\",\"ColorWheel.stories.85c69a14.js\",\"hSjnu\",\"ColorWheel.stories.38d020e8.css\",\"6tKxu\",\"ComboBox.stories.a3ec9e8c.js\",\"3NcAc\",\"ComboBox.stories.e70b87f4.css\",\"iOFO0\",\"ContextualHelp.stories.150db62b.js\",\"dOZEb\",\"ContextualHelp.stories.164862cb.css\",\"6IZDQ\",\"Dialog.stories.b4e8fa95.js\",\"bD9N0\",\"Dialog.stories.cdeff6f6.css\",\"2sGnZ\",\"Disclosure.stories.c1bf9cc3.js\",\"1Ddrz\",\"Disclosure.stories.c830083f.css\",\"grt1r\",\"Divider.stories.ac96fb3d.js\",\"lAbUa\",\"Divider.stories.cb3574e0.css\",\"ckIkk\",\"DropZone.stories.41bb3491.js\",\"klh8U\",\"DropZone.stories.11f9366f.css\",\"gb7T0\",\"Form.stories.d30964bb.js\",\"9pxqx\",\"Form.stories.d6fd2ce4.css\",\"5ZmAZ\",\"Icon.stories.ee6998db.js\",\"339Sr\",\"Icon.stories.6b97024d.css\",\"k0suk\",\"IllustratedMessage.stories.e2073af8.js\",\"7xTMw\",\"IllustratedMessage.stories.46dbc197.css\",\"7kQkU\",\"InlineAlert.stories.d2e7c345.js\",\"kAepE\",\"InlineAlert.stories.e97e8400.css\",\"1BGYx\",\"Link.stories.53142d64.js\",\"faD2d\",\"Link.stories.1e426198.css\",\"6stl4\",\"LinkButton.stories.d8284482.js\",\"URmMV\",\"LinkButton.stories.1815864a.css\",\"5OyCA\",\"Menu.stories.4563aa75.js\",\"1X6Yq\",\"normal.ded32008.png\",\"1cUbH\",\"multiply.9c18c7f4.png\",\"jJ0Qw\",\"screen.88c89678.png\",\"35TCD\",\"Menu.stories.571d6a7f.css\",\"2Eyel\",\"Meter.stories.774c5433.js\",\"2X7Zg\",\"Meter.stories.12bca29b.css\",\"5cpcj\",\"NumberField.stories.4afa2151.js\",\"hRc7I\",\"NumberField.stories.c3206320.css\",\"daCbk\",\"Picker.stories.3d8364cd.js\",\"9sN1C\",\"Picker.stories.692786fa.css\",\"5IDLy\",\"ProgressBar.stories.e4db1c94.js\",\"fRS9T\",\"ProgressBar.stories.4350ef1e.css\",\"ai50H\",\"ProgressCircle.stories.31d39f17.js\",\"fu2Ow\",\"ProgressCircle.stories.e53235f8.css\",\"avmna\",\"RadioGroup.stories.d30fea80.js\",\"4Nt1c\",\"RadioGroup.stories.f6de042e.css\",\"6gPUm\",\"RangeSlider.stories.503d06d9.js\",\"duwKF\",\"RangeSlider.stories.ef1df7ca.css\",\"5K8dM\",\"SearchField.stories.bdb2fc42.js\",\"fQcxp\",\"SearchField.stories.64f8b5b2.css\",\"iLurC\",\"SegmentedControl.stories.e87e52f9.js\",\"fJ5gG\",\"SegmentedControl.stories.e1cac07b.css\",\"8WY0L\",\"Slider.stories.a16bf7b0.js\",\"2G1l1\",\"Slider.stories.7fa41ae3.css\",\"04sgd\",\"StatusLight.stories.1fea2a0d.js\",\"YLZcY\",\"StatusLight.stories.89b7260d.css\",\"7HQVi\",\"StyleMacro.stories.e44255e7.js\",\"6irk7\",\"StyleMacro.stories.ae045ce6.css\",\"j0C0i\",\"Switch.stories.4d9bb2b8.js\",\"d9qLv\",\"Switch.stories.55d29f4c.css\",\"dUWp4\",\"TableView.stories.ddfdd443.js\",\"e1JjP\",\"TableView.stories.5f4ba300.css\",\"eYeYC\",\"Tabs.stories.c9b0ed27.js\",\"feZGY\",\"Tabs.stories.5d97fce4.css\",\"imVpz\",\"TagGroup.stories.614297cc.js\",\"dLyIZ\",\"TagGroup.stories.0cf1bc4e.css\",\"cFWhT\",\"TextField.stories.ffcaa133.js\",\"bHL5a\",\"TextField.stories.39a25bf4.css\",\"dJiy9\",\"ToggleButton.stories.7dafc9a3.js\",\"5iqzW\",\"ToggleButton.stories.d0d25a73.css\",\"89Kdl\",\"Tooltip.stories.2e1e1ecf.js\",\"8wfUX\",\"Tooltip.stories.dabce69a.css\",\"1q8TQ\",\"entry-preview.e1c24c08.js\",\"aSOm6\",\"entry-preview-docs.07fc3f4f.js\",\"392zD\",\"entry-preview-docs.a48a5117.js\",\"2mrM9\",\"preview.653ede3f.js\",\"4emjP\",\"preview.1cfd08b0.js\",\"9KfW9\",\"react.9fdb4c8e.js\",\"juv5f\",\"preview.2041b5be.js\",\"bhJYu\",\"Color-6VNJS4EI.d365da91.js\",\"6Frmr\",\"syntaxhighlighter-B5GMVT5T.9ff411bc.js\",\"fj7es\",\"formatter-SWP5E3XI.8ce9aa2a.js\",\"922rR\",\"WithTooltip-V3YHNWJZ.51f0b2af.js\",\"3aHv1\",\"preview.1f626eb6.js\",\"ecYEr\",\"preview.c7b3273b.js\",\"3tbxb\",\"preview.fea4e833.js\",\"fWlhU\",\"preview.96c46ec7.js\",\"d9MnS\",\"preview.db0dee2a.js\",\"kjrzv\",\"preview.88b698d4.js\",\"53zxi\",\"preview.668e60cb.js\",\"gEMMp\",\"logo.5ec3ca99.svg\",\"5LK7O\",\"logo-dark.bdeff35f.svg\",\"bgXJi\",\"preview.e6a9e9c6.css\"]"));

},{"37e082b46bb0aa0e":"kK08P","8df2cd897b26d95b":"kMf2L"}],"kK08P":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"kMf2L":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["10bty"], null, "parcelRequire94c2")

//# sourceMappingURL=iframe.runtime.5821496c.js.map
